import { z } from 'zod';
import { ITEM_ROLES, PROJECT_ROLES, STATUS_CATEGORIES } from '../enums';
import { uuid } from './common';

export const statusSchema = z.object({
  key: z.string().regex(/^[a-z][a-z0-9_]{1,40}$/),
  name: z.string().min(1).max(60),
  category: z.enum(STATUS_CATEGORIES),
  order: z.number().int().min(0).optional(),
});
export type StatusInput = z.infer<typeof statusSchema>;

export const transitionDefSchema = z.object({
  fromStatusId: uuid.nullable(),
  toStatusId: uuid,
  name: z.string().min(1).max(60),
  allowedRoles: z.array(z.enum(PROJECT_ROLES)).default([]),
  requiredFields: z.array(z.string()).default([]),
  requiresHandoffNote: z.boolean().default(false),
  /** Phase 2 (FR-WF-7): moving through this transition needs an approver's decision. */
  requiresApproval: z.boolean().default(false),
  assignToRole: z.enum(ITEM_ROLES).nullable().default(null),
});
export type TransitionDefInput = z.infer<typeof transitionDefSchema>;

export const workflowSchema = z.object({
  name: z.string().min(1).max(80),
  issueTypeIds: z.array(uuid).default([]),
});
export type WorkflowInput = z.infer<typeof workflowSchema>;
